import { TIMEZONE_FETCHED } from "../actions";

export const initialState = {};

export type TimezonesState = typeof initialState;

export default function(state = initialState, action) {
	switch (action.type) {
		case TIMEZONE_FETCHED: {
			return { ...state, [action.index]: action.timezone };
		}

		default:
			return state;
	}
}
